import { AnyAction } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from '../redux/store';

import { LinkSizeIcon, LinkSizeText, LinkType } from '../components/Link';
import { SizeText } from '../components/Case';
import { Video } from './page';

/* INTERFACES */
export interface Image {
  src?: string;
  alt?: string;
  width?: number;
  height?: number;
  type?: string;
  isParallaxImage?: boolean;
  layout?: 'responsive' | 'intrinsic' | 'fixed' | 'fill' | undefined;
  loading?: 'lazy' | 'eager';
  sizes?: string;
  priority?: boolean;
  quality?: number;
}

export interface LinkStyle {
  type: LinkType;
  iconSize: LinkSizeIcon;
  isIconFirst: boolean;
  textSize: LinkSizeText;
}

export interface Link {
  url: string;
  label: string;
  isExternal?: boolean;
  style?: LinkStyle;
}

export interface TitleDescriptionFormat {
  title: string;
  text: string;
}

export interface LogosFormat {
  title: string;
  img: Image;
}

export interface BenefitsFormat {
  title: string;
  text: string;
  link: Link;
}

export interface TeamMembersFormat {
  className?: string;
  index?: number;
  id?: number;
  type: string;
  name?: string;
  link?: Link;
  image: Image;
  role?: string;
  question?: string;
  answer?: string;
  phrase?: string;
  delay?: number;
  stackDelay?: number;
  zIndex?: number;
  anim?: boolean;
  isLast?: boolean;
  indexOf?: number;
  rotate?: number;
  onAnimationComplete?: () => void;
}

export interface TeamListMember {
  type: string;
  name?: string;
  link?: Link;
  image: Image;
  role?: string;
  question?: string;
  answer?: string;
  phrase?: string;
  delay?: number;
}

export type TAction<R = void> = ThunkAction<R, RootState, unknown, AnyAction>;

export interface SingleImageContainerFormat {
  size: IMAGESIZECONTAINER;
  image?: Image;
  images?: Image[];
  video?: Video;
  isParallaxImage?: boolean;
}

export interface MultipleImageContainerFormat {
  size: IMAGESIZECONTAINER;
  images: (Video | Image | undefined)[];
  id: number;
}

export interface CaseFormat {
  title: string;
  link?: Link;
  titleSizeText?: SizeText;
  linkSizeText?: LinkSizeText;
  image: Image;
}
/* END OF INTERFACES */

/* ENUMS */
export enum TITLESIZE {
  EXTRALARGE = 'h1',
  LARGE = 'h2',
  EXTRAMEDIUM = 'h3',
  MEDIUM = 'h4',
  SMALL = 'h5',
  EXTRASMALL = 'h6',
  DEFAULT = 'h2',
}

export enum SUBTITLESIZE {
  EXTRALARGE = 'text_1',
  LARGE = 'text_2',
  EXTRAMEDIUM = 'text_3',
  MEDIUM = 'text_4',
  SMALL = 'text_5',
  EXTRASMALL = 'text_6',
  DEFAULT = 'text_1',
}

export enum TEXTPOSITION {
  LEFT = 'textLeft',
  RIGHT = 'textRight',
  CENTER = 'textCenter',
  DEFAULT = '',
}

export enum IMAGESIZECONTAINER {
  FULLWIDTH = 'full_width',
  HALFWIDTH = 'half_width',
  THIRTYSEVENTYWIDTH = 'thirty_seventy_width',
  SEVENTYTHIRTYWIDTH = 'seventy_thirty_width',
  LARGEWIDTH = 'large_width',
  ONETHIRDWIDTH = 'one_third_width',
}
/* END OF ENUMS */

export interface SubmitMessage {
  type: 'error' | 'success';
  message: string;
}

export interface MembersNthTerms {
  nthTerms: number[];
  mobileNthTerms: number[];
  firstChildNthTerms: number[];
  thirdChildNthTerms: number[];
}

export interface MemberClassNamesTerms {
  nthClass: string;
  evenClass: string;
  firstChildClass: string;
  thirdChildNthClass: string;
  mobileNthClass: string;
}
